import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info as InfoIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./../Tooltip";
import InfoContent from "./InfoContent";
const Info = () => {
    return (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { children: _jsx(InfoIcon, { className: "text-gray-300" }) }), _jsx(TooltipContent, { className: "transition-all duration-200", side: "bottom", align: "center", sideOffset: 20, children: _jsx(InfoContent, {}) })] }));
};
export default Info;
